import React, { useState, useContext, useEffect } from "react";

import ContextApp from "../../../core/contexts/context.app";
import OrderList from "./OrderList";

function UserOrder() {
  const ctx = useContext(ContextApp);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <OrderList />
    </>
  );
}
export default UserOrder;
